// Vendor
// Actions
import { combineReducers, createReducer, on } from '@ngrx/store';
import { addAllMatrices, decrementCurrentWizardStep, incrementCurrentWizardStep, resetClientResultsLoaded, resetCurrentWizardStep, resetMatrixResultsLoaded, resetSelectedMatrices, selectClient, selectMatrix, setClientResultsLoaded, setMatrixResultsLoaded, setPortfolioImportType, } from './actions';
// Constants
import { MODEL_PORTFOLIO } from 'ModelPortfolioApp/ts/shared/constants';
export const currentWizardStepIndex = createReducer(0, on(incrementCurrentWizardStep, (state) => state + 1), on(decrementCurrentWizardStep, (state) => state - 1), on(resetCurrentWizardStep, () => 0));
export const portfolioImportType = createReducer(MODEL_PORTFOLIO, on(setPortfolioImportType, (state, { newPortfolioImportType }) => newPortfolioImportType));
export const selectedClient = createReducer(null, on(selectClient, (state, { selectedClient: newClient }) => newClient));
export const selectedMatrices = createReducer([], on(selectMatrix, (state, { selectedMatrix: newMatrix }) => {
    if (state.some((m) => m.id === newMatrix.id)) {
        return state.filter((m) => m.id !== newMatrix.id);
    }
    return [...state, newMatrix];
}), on(addAllMatrices, (state, { matrices }) => {
    return matrices.map((m) => ({ id: m.id, name: m.name }));
}), on(resetSelectedMatrices, () => []));
export const clientResultsLoaded = createReducer(false, on(setClientResultsLoaded, (state, { loaded }) => loaded), on(resetClientResultsLoaded, () => false));
export const matrixResultsLoaded = createReducer(false, on(setMatrixResultsLoaded, (state, { loaded }) => loaded), on(resetMatrixResultsLoaded, () => false));
export const hartfordImportHoldings = combineReducers({
    currentWizardStepIndex,
    portfolioImportType,
    selectedClient,
    selectedMatrices,
    clientResultsLoaded,
    matrixResultsLoaded,
});
